export type ThemeMode = 'light' | 'dark' | 'system';

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }
  return 'light';
}

/**
 * Apply desired theme to the app by invoking a provided toggle function
 * when the current app theme does not match the desired theme.
 */
export function applyThemeToApp(
  themeMode: ThemeMode,
  isCurrentThemeDark: boolean,
  toggleTheme: () => void
): void {
  switch (themeMode) {
    case 'light': {
      if (isCurrentThemeDark) toggleTheme();
      break;
    }
    case 'dark': {
      if (!isCurrentThemeDark) toggleTheme();
      break;
    }
    case 'system': {
      const systemTheme = getSystemTheme();
      if (systemTheme === 'dark' && !isCurrentThemeDark) {
        toggleTheme();
      } else if (systemTheme === 'light' && isCurrentThemeDark) {
        toggleTheme();
      }
      break;
    }
    default:
      break;
  }
}
